// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1Nq85","info":"PatientInfo_info__3MlQO"};